<template>
  <div id="container-title">
    <div id="generic-title">
      <p>Resultado de la consulta</p>
    </div>
    <div id="specific-title">
      <p>Lo sentimos, pero no hay datos disponibles para la estación</p>
      <p> <b>{{ station_name }}</b> desde <b>{{  initDate }}</b> hasta <b>{{ endDate }}</b></p>
      <p id="invitation-title">Lo invitamos a realizar otra consulta</p>
    </div>
  </div>
  </template>

  <script>
  import { mapState } from 'vuex'

  export default {
    name: 'TableScreenNoData',
    computed: {
      ...mapState(['station_name', 'initDate', 'endDate'])
    },
  }
  </script>

  <style scoped>
  #container-title {
    cursor: default;
    display: flex;
    flex-flow: row wrap;
    max-width: 100%;
    text-align: center;
    margin-bottom: 1.2rem;
  }
  #generic-title {
    color: rgb(100, 120, 20);
    margin-top: 1em;
    font-size: 1.7em;
    width: 85%;
    font-family: "Ancizar-bold", Helvetica, Arial;
    margin-left: 9rem;
  }
  #specific-title {
    margin-top: 1em;
    font-size: 1.2em;
    width: 85%;
    font-family: "Ancizar-bold", Helvetica, Arial;
    margin-left: 8rem;
  }
  #invitation-title {
    color: rgb(100, 120, 20);
    margin: 1rem 0rem 0rem 20rem;
    font-size: 1.2em;
    width: 45%;
    font-family: "Ancizar-bold", Helvetica, Arial;
    border-bottom: .1rem dashed;
  }
  </style>